import ShInputSelect from './sh-input-select.js';

export default ShInputSelect;



// WEBPACK FOOTER //
// ./src/index.js